import React from 'react';
import './App.css';
import Header from './components/Header';
import ApplicationForm from './components/ApplicationForm';

function App() {
  const renderReturnButton = () => {
    return (
      <a 
        href="https://www.pacificwarmuseum.org/about/admiral-nimitz-foundation"
        className="return-to-museum-btn"
      >
        Return to Museum Site
      </a>
    );
  };
  
  return (
    <div className="app">
      {renderReturnButton()}
      <Header />
      <main className="main-content">
        <ApplicationForm />
      </main>
    </div>
  );
}

export default App; 